import React from "react";
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";
import { twMerge } from "tailwind-merge";
import { ArrowNarrowRightIcon, ChevronRightIcon } from "@heroicons/react/solid";
import { useI18nLink } from "../../hooks/useI18nLink";
import { useScheduleCallUrl } from "../../hooks/useScheduleCallUrl";
import { Theme, useThemed } from "../../hooks/useTheme";
import { Button } from "../Button";

interface HeroCtaProps {
  center?: boolean;
  methodCta?: boolean;
  scheduleCallCta?: boolean;
  className?: string;
  theme?: Theme;
}

export const HeroCta: React.FunctionComponent<HeroCtaProps> = ({
  center = false,
  methodCta = false,
  scheduleCallCta = false,
  theme,
  className,
}) => {
  const { t } = useTranslation();
  const i18nLink = useI18nLink();
  const callUrl = useScheduleCallUrl();
  const alone = !methodCta && !scheduleCallCta;
  const themed = useThemed(theme);

  return (
    <div className="mt-5 sm:mt-8  w-full">
      <div
        className={twMerge(
          `md:flex items-center justify-center space-y-2 md:space-y-0 md:space-x-2  w-full`,
          !center && "md:justify-start",
          className,
        )}
      >
        <Button
          theme={theme}
          to="#contact-form"
          anchor
          label={t("common:cta.mail")}
          variant={alone ? "secondary" : "primary"}
        />
        {methodCta ? (
          <Button
            theme={theme}
            to={i18nLink("method")!}
            label={t("common:cta.method")}
            variant="secondary"
            icon={<ArrowNarrowRightIcon />}
          />
        ) : scheduleCallCta ? (
          <Button
            theme={theme}
            to={callUrl}
            target="_blank"
            label={t("common:cta.scheduleCall")}
            variant="secondary"
            icon={<ArrowNarrowRightIcon />}
          />
        ) : null}
      </div>
      {!scheduleCallCta && (
        <p
          className={twMerge(
            "text-lg mt-3 italic",
            themed({
              dark: "text-gray-300",
              indigo: "text-gray-300",
              white: "text-gray-600",
              gray: "text-gray-600",
            }),
            center ? "text-center" : "",
          )}
        >
          <Trans
            i18nKey="common:cta.callInstead"
            components={{
              a: (
                <a
                  href={callUrl}
                  target="_blank"
                  className={twMerge(
                    " underline",
                    themed({
                      dark: "text-indigo-400",
                      indigo: "text-indigo-400",
                      white: "text-indigo-700",
                      gray: "text-indigo-700",
                    }),
                  )}
                />
              ),
            }}
          />
        </p>
      )}
    </div>
  );
};
